import { cbSemanticCssVars, WoltLogo } from '@creditornot/cb-ingredients';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import HeaderContents from './HeaderContents';

const HeaderWoltLogo = styled(WoltLogo)`
  width: 80px;
  fill: ${cbSemanticCssVars.textPrimary};
  align-self: flex-start;
  justify-content: center;
`;

const Root = styled.div`
  position: relative;
  display: flex;
  padding: 2rem 2rem 0;
  height: 60px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  max-width: 100%;
  z-index: 1000;
  align-items: center;
`;

const Left = styled.div`
  flex: 0 0 auto;
  width: 75px;
`;

const Right = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 75px;
`;

const Center = styled.div`
  flex: 1 1 auto;
  display: flex;
  min-width: 0;

  @media (width <= 640px) {
    justify-content: center;
  }
`;

const LoggedOutHeader = () => {
  const { pathname } = useLocation();
  const rootRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    rootRef.current && rootRef.current.scrollIntoView();
  }, [pathname]);

  return (
    <Root ref={rootRef}>
      <Left>
        <HeaderWoltLogo />
      </Left>
      <Center />
      <Right>
        <HeaderContents />
      </Right>
    </Root>
  );
};

export default LoggedOutHeader;
